import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-kpi-tile',
  templateUrl: './kpi-tile.component.html',
  styleUrl: './kpi-tile.component.scss',
  standalone: false,
})
export class KpiTileComponent {
  @Input() label = '';
  @Input() value = 0;
  @Input() diffPercent: number | null = null;
  @Input() diffAbsolute = 0;

  get hasPercent(): boolean {
    return this.diffPercent !== null && this.diffPercent !== undefined;
  }

  // Absolute change is the fallback when a zero prior value makes percent unavailable.
  get showAbsolute(): boolean {
    return !this.hasPercent && this.diffAbsolute !== 0;
  }

  get comparisonValue(): number | null {
    if (this.hasPercent) return this.diffPercent;
    if (this.showAbsolute) return this.diffAbsolute;
    return null;
  }
}
